import { UI } from './ui';

document.addEventListener("DOMContentLoaded", () => {
    UI.init();
    UI.nav.bind();
    UI.sidebar.bind();    
    UI.tabs.bind();
    // UI.gallery.init();
    // UI.player.bind();
    // UI.video.bind();   
    // UI.modal.bind(); 
    UI.slider.bind();
    //UI.header.bind();

    UI.slider.bind('.products-slider', {
        speed: 400,
        slidesPerView: 2,
        spaceBetween: 8,
        loop: false,
        autoplay: false,
        breakpoints: {
            //settings for viewport bigger than 960px
            960: {
                slidesPerView: 5,
                spaceBetween: 16,
            },
        },        
    }, false);
});

window.addEventListener('resize', () => { UI.init() } );

